'use client'

import { useEffect } from 'react'
import { resolveBlockType } from '../registry/blocks-registry'
import { findTabIdForSection } from '../models/notebook-model'
import { registerBlockPasteHandlers } from './paste-handlers'
import { useNotebookStore } from './store'
import { normalizeTabsBlockData } from '../models/tabs-model'

function findTabChildBlockLocation(notebook, blockId) {
  for (const themeTab of notebook.tabs) {
    for (const section of themeTab.sections) {
      if (resolveBlockType(section.type) !== 'block_tabs') continue
      const tabsData = normalizeTabsBlockData(section.data)
      for (const innerTab of tabsData.tabs) {
        const hit = innerTab.blocks?.some((b) => b.id === blockId)
        if (hit) {
          return { sectionId: section.id, innerTabId: innerTab.id }
        }
      }
    }
  }
  return null
}

function restorePasteUndo(blockId, snapshot) {
  const store = useNotebookStore.getState()
  const { notebook } = store

  if (findTabIdForSection(notebook, blockId)) {
    store.updateSection(blockId, snapshot)
    return true
  }

  const loc = findTabChildBlockLocation(notebook, blockId)
  if (loc) {
    store.updateTabBlock(loc.sectionId, loc.innerTabId, blockId, snapshot)
    return true
  }

  return false
}

/** Registers paste handlers + block-scoped Cmd/Ctrl+Z undo (notebook route). */
export function NotebookPasteInit() {
  useEffect(() => {
    registerBlockPasteHandlers()
  }, [])

  useEffect(() => {
    const onKeyDown = (e) => {
      if (!(e.metaKey || e.ctrlKey) || e.key !== 'z' || e.shiftKey) return

      const host = document.activeElement?.closest?.('[data-section-id]')
      const blockId = host?.getAttribute?.('data-section-id')
      if (!blockId) return

      const prev = useNotebookStore.getState().popUndoSnapshot(blockId)
      if (!prev) return

      if (!restorePasteUndo(blockId, prev)) return

      e.preventDefault()
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [])

  return null
}
